/* eslint-disable */
export default {
  _snigletregular: 'snigletregular',
}